import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { PageHeader, Loading } from "@/components/PageUI";
import { LibraryManager } from "@/components/creative/LibraryManager";
import MediaPanel from "@/components/creative/MediaPanel";
import { FolderOpen } from "lucide-react";

export default function MediaLibrary() {
  const { data: projects, isLoading } = useQuery({
    queryKey: ["studio-projects"],
    queryFn: () => api.get("/creative/projects").then(r => r.data),
    retry: false,
  });
  const [selected, setSelected] = useState(""), [view, setView] = useState("library");
  if (isLoading) return <Loading />;
  const active = selected || projects?.[0]?.id || "";

  return <>
    <PageHeader eyebrow="AI Creative Studio" title="My library" description="Your uploads and saved finished videos, together across projects. Organise them into folders and reuse them in your next edit. Private to your account." />
    <div className="library-view-tabs"><button type="button" className="secondary-btn" aria-pressed={view === "library"} onClick={() => setView("library")} data-testid="media-view-library">My library</button><button type="button" className="secondary-btn" aria-pressed={view === "projects"} onClick={() => setView("projects")} data-testid="media-view-projects">Project uploads</button></div>
    {view === "library" ? <LibraryManager/> : (!projects || projects.length === 0) ? <div className="empty-state" data-testid="media-no-projects"><strong>No projects yet</strong><p>Create a project in the Studio dashboard to upload media.</p></div> :
      <section className="analytics-grid">
        <article className="panel" data-testid="project-picker-panel">
          <span className="eyebrow">PROJECTS</span><h2>Choose a project</h2>
          <div className="studio-project-grid">
            {projects.map(p => <button key={p.id} className={`studio-project-card ${active === p.id ? "is-active" : ""}`} onClick={() => setSelected(p.id)} data-testid={`media-project-${p.id}`}>
              <FolderOpen size={18} /><div><b>{p.name}</b><small>{p.kind === "ad_clone" ? "Ad Clone" : "AI Influencer"}</small></div>
            </button>)}
          </div>
        </article>
        <article className="panel" data-testid="media-manage-panel">
          <span className="eyebrow">MEDIA</span><h2>Upload & manage</h2>
          {active && <MediaPanel projectId={active} />}
        </article>
      </section>}
  </>;
}
